import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useHistory } from "react-router-dom";

const Bill = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const billData = useSelector(
    (state) => state?.financeReducer?.refundsBillData
  );
  const pageType = params.location.state;
  console.log(billData, "billData", pageType);
  function getRefund(el, payEl) {
    if (payEl?.refund != 0) return "Refunded";
    else if (el?.order_status_id == 2) return "Paid";
    else return "Unpaid";
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  <div className="field text-right my-3 pt-1 px-0">
                    <button
                      onClick={() => history.goBack()}
                      class="btn green-btn-revert mx-0"
                      id="addCount"
                      type="button"
                    >
                      Back to Refunds
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <h4 class="event-alert">
                            Bills{" "}
                            <p class="billno-right">
                              {" "}
                              ORDER ID #{billData?.pos_order_id}
                            </p>
                          </h4>
                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="col-md-4 col-12"></div>
                            <div class="col-sm-auto text-small align-right col-12 mt-2 mt-sm-0">
                              <i>Last Upload July 13, 2022 02:23 PM</i>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Bill #</th>
                                    <th>Status</th>
                                    <th>Pay Method </th>
                                    <th># of Items</th>
                                    <th>Gross Sales</th>
                                    <th>VOIDs</th>
                                    <th>Discounts</th>
                                    <th>Service Charges</th>
                                    <th>Net Sales</th>
                                    <th>Tax </th>
                                    <th>Tips</th>
                                    <th>Amount Paid</th>
                                    <th>Refund</th>
                                    <th className="action-td">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {billData?.bills?.map((el) =>
                                    el?.pos_payment_detail?.map((payEl) => (
                                      <tr>
                                        <td>
                                          {el?.order_id + "_" + payEl?.id}
                                        </td>
                                        <td>{getRefund(el, payEl)}</td>
                                        <td>{payEl?.payment_type}</td>
                                        <td>{payEl?.order_quantity}</td>
                                        <td>{payEl?.gross_sale}</td>
                                        <td>{payEl?.void}</td>
                                        <td>{payEl?.discount}</td>
                                        <td>{payEl?.service_charge}</td>
                                        <td>{payEl?.net_sales}</td>
                                        <td>{payEl?.sales_tax}</td>
                                        <td>{payEl?.tips}</td>
                                        <td>
                                          {payEl?.amount_paid != 0
                                            ? payEl?.amount_paid
                                            : payEl?.payment_amount}
                                        </td>
                                        <td>{payEl?.refund}</td>
                                        <td className="action-td">
                                          {" "}
                                          <a
                                            onClick={() => {
                                              dispatch(
                                                actions?.getInnerMenuItemsData({
                                                  order_id: payEl?.pos_order_id,
                                                  page: pageType,
                                                  bill_id: payEl?.id,
                                                })
                                              );
                                              history.push(
                                                "/finance/sales/inner-menu-items",
                                                {
                                                  heading: "bill",
                                                  pageType: pageType,
                                                }
                                              );
                                            }}
                                            class="circle_icon"
                                          >
                                            <i class="iconSprites eye-icon"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default Bill;
